import { render, staticRenderFns } from "./CreateMaterialTagPopup.vue?vue&type=template&id=3971ebe3"
import script from "./CreateMaterialTagPopup.vue?vue&type=script&lang=js"
export * from "./CreateMaterialTagPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports